export default function OtherResourcesDirective() {
  return {
    template: require('./other-resources.html'),
    scope: {
      assessmentId: '=',
      status: '@',
    },
    controller: 'OtherResourcesController',
    controllerAs: 'otherResourcesVM',
    bindToController: true,
    replace: true,
  };
}
